import escapeCsvFormulaValue from './escapeCsvFormulaValue';
import escapeDelimitedValue from './escapeDelimitedValue';

// Guard first, so the added prefix still reaches the quoting decision, e.g. when ' is the delimiter.
const escapeCsvField = (
  value: string,
  delimiter: string,
  isNumberColumn = false
): string =>
  escapeDelimitedValue(escapeCsvFormulaValue(value, isNumberColumn), delimiter);

export default escapeCsvField;
